// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

export const ActionContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { action, _id: baseId, details = {}, context } = base;

    const { case: dataCase, alert: dataAlert } = data.context || {};

    const title = details?.['responderName'] || '';

    const dataParent = dataCase || dataAlert || context || {};

    const customDetails = {
        status: action === 'create' ? 'Started' : details.status,
        cortexId: details.cortexId,
        startDate: details.startDate,
        endDate: details.endDate,
    };

    const titleComplement = action === 'create' ? '' : ` [${local('stream.terminated')}]`;

    if (action !== 'create') {
        delete customDetails.startDate;
    } else {
        delete customDetails.endDate;
    }

    return (
        <StreamCard icon={<ICONS.RunResponderIcon />} title={title + titleComplement} base={base} parent={dataParent}>
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={baseId + key} prop={key} value={value} type="action" />
            ))}
        </StreamCard>
    );
};
